import { getAuth, getClientId } from './../config.env'
export const msalConfig = {
    auth: {
        clientId: getClientId(), //'69b3f6fe-980a-431c-90ea-3f5b19e77314',
        authority:
            'https://infixusersb2ctest.b2clogin.com/infixusersb2ctest.onmicrosoft.com/B2C_1_SignIn',
        knownAuthorities: ['infixusersb2ctest.b2clogin.com'],
        redirectUri: getAuth(),
    },
    cache: {
        cacheLocation: 'localStorage',
        storeAuthStateInCookie: false,
    },
}
